export const GUEST_PORTAL_DEFAULTS = {
  modules: {
    dine: true,
    roomService: true,
    buffet: true,
    offers: true,
    housekeeping: true,
    laundry: true,
    maintenance: true,
    amenities: true,
    stay: true,
    concierge: true,
    help: true,
    requests: true,
    rate: true,
    events: true,
  },
  events: [
    {
      id: "moonlight-wellness",
      title: "Moonlight Wellness Night",
      eyebrow: "Special event",
      when: "Tonight",
      where: "Spa pavilion",
      hint: "Yoga, spa rituals, healthy bites, and live music under the moon.",
      price: "LKR 6,000 per person",
      cta: "Reserve your spot",
      image: "/assets/guest-events/moonlight-wellness.jpg",
    },
    {
      id: "sunset-bbq",
      title: "Sunset BBQ & Live Music",
      eyebrow: "Special event",
      when: "Saturday, September 12 · 6:30 PM – 10:00 PM",
      where: "Poolside Terrace",
      hint: "Live acoustic band, BBQ buffet, welcome drink, and kid-friendly activities.",
      price: "LKR 7,500 per person",
      cta: "Reserve your spot",
      image: "/assets/guest-events/sunset-bbq.jpg",
    },
    {
      id: "afternoon-high-tea",
      title: "Afternoon High Tea",
      eyebrow: "Special event",
      when: "Sunday, September 28 · 3:00 PM – 5:00 PM",
      where: "The Lounge",
      hint: "Teas, sandwiches, scones, and a live piano performance.",
      price: "LKR 4,500 per person",
      cta: "Book your table",
      image: "/assets/guest-events/afternoon-high-tea.jpg",
    },
  ],
  stay: {
    wifiName: "Hotel-Guest",
    wifiPassword: "Welcome123",
    checkoutTime: "12:00",
    checkinTime: "14:00",
    frontDeskPhone: "",
    emergencyPhone: "911",
    conciergePhone: "",
    parking: "Valet at the lobby. Self-park in basement B1.",
    policies:
      "Quiet hours 10:00 PM – 7:00 AM. Smoking is not allowed in rooms. Late checkout is subject to availability.",
    directory:
      "Lobby & reception — Ground floor. All-day dining — Level 1. Pool & gym — Level 3. Spa — Level 4.",
  },
  buffet: {
    location: "All-day dining restaurant, Level 1",
    dress: "Smart casual",
    kidsNote: "Children under 6 eat free with a dining adult.",
    dietaryNote: "Vegetarian, vegan, and gluten-free stations are labelled.",
    meals: [
      {
        id: "breakfast",
        title: "Breakfast buffet",
        hours: "6:30 AM – 10:30 AM",
        highlights: ["Live omelette station", "Tropical fruit", "Fresh juices", "Pastries"],
      },
      {
        id: "lunch",
        title: "Lunch buffet",
        hours: "12:00 PM – 3:00 PM",
        highlights: ["Salad bar", "Carving station", "Asian noodles", "Desserts"],
      },
      {
        id: "dinner",
        title: "Dinner buffet",
        hours: "6:30 PM – 10:00 PM",
        highlights: ["Seafood", "Grill", "Curries", "Live dessert counter"],
      },
    ],
  },
  facilities: [
    { id: "pool", title: "Pool", hours: "6:00 AM – 10:00 PM", note: "Towels at the pool deck." },
    { id: "gym", title: "Fitness centre", hours: "24 hours", note: "Key card access after 10:00 PM." },
    { id: "spa", title: "Spa", hours: "9:00 AM – 9:00 PM", note: "Book from Concierge or the front desk." },
    { id: "kids", title: "Kids club", hours: "9:00 AM – 6:00 PM", note: "Ages 4–12. Ground floor." },
  ],
  catalogs: {
    housekeeping: {
      etaMinutes: 20,
      whatHappensNext: "Housekeeping will come to your room. Hang the privacy sign if you need a little time.",
      items: [
        { id: "towels", title: "Extra towels", hint: "Fresh bath towels delivered to your room" },
        { id: "linen", title: "Extra linen", hint: "Sheets, pillowcases, or a blanket" },
        { id: "clean-now", title: "Clean my room now", hint: "Ask for service as soon as a attendant is free" },
        { id: "turndown", title: "Turndown service", hint: "Evening tidy, lights, and extra water" },
        { id: "pillows", title: "Extra pillows", hint: "Soft, firm, or extra cushions" },
        { id: "makeup", title: "Make up room", hint: "Full tidy while you are out" },
      ],
    },
    laundry: {
      etaMinutes: 24 * 60,
      whatHappensNext: "We’ll collect from your room. Same-day return is usually by 7:00 PM if picked up before 10:00 AM.",
      items: [
        {
          id: "wash-fold",
          title: "Wash & fold",
          hint: "Everyday clothes",
          extraField: { type: "time", label: "Pickup time" },
        },
        {
          id: "iron",
          title: "Pressing / ironing",
          hint: "Shirts, trousers, dresses",
          extraField: { type: "time", label: "Pickup time" },
        },
        {
          id: "dry-clean",
          title: "Dry cleaning",
          hint: "Suits and delicate garments",
          extraField: { type: "time", label: "Pickup time" },
        },
      ],
    },
    maintenance: {
      etaMinutes: 30,
      whatHappensNext: "Engineering will knock before entering. For urgent issues, call the front desk.",
      items: [
        { id: "ac", title: "Air conditioning", hint: "Too cold, too warm, or not cooling" },
        { id: "tv", title: "TV / entertainment", hint: "No signal, remote, or streaming help" },
        { id: "plumbing", title: "Plumbing", hint: "Tap, shower, or toilet" },
        { id: "wifi-issue", title: "Wi-Fi not working", hint: "We’ll reset or send a technician" },
        { id: "lights", title: "Lights or power", hint: "Bulbs, sockets, or a dark room" },
        { id: "other", title: "Something else", hint: "Describe the issue in the note" },
      ],
    },
    amenities: {
      etaMinutes: 15,
      whatHappensNext: "Items are brought to your door. Add a note if you need a specific brand or size.",
      items: [
        { id: "toiletries", title: "Toiletries", hint: "Shampoo, soap, toothbrush, razor" },
        { id: "iron", title: "Iron & board", hint: "Delivered to the room" },
        { id: "extra-bed", title: "Extra bed / rollaway", hint: "Subject to availability" },
        { id: "baby-cot", title: "Baby cot", hint: "Subject to availability" },
        { id: "minibar", title: "Minibar refill", hint: "Water, snacks, or a restock" },
        { id: "kettle", title: "Kettle / tea & coffee", hint: "Extra cups or a fresh set" },
      ],
    },
    concierge: {
      etaMinutes: 10,
      whatHappensNext: "The concierge or front desk will confirm by phone or at your door.",
      items: [
        {
          id: "wakeup",
          title: "Wake-up call",
          hint: "We’ll ring your room",
          extraField: { type: "time", label: "Call me at" },
        },
        { id: "taxi", title: "Taxi / airport transfer", hint: "Tell us the time and destination" },
        { id: "tours", title: "Tours & tickets", hint: "City tours, shows, or reservations" },
        { id: "late-checkout", title: "Late checkout", hint: "We’ll check availability for your room" },
        { id: "extra-night", title: "Stay another night", hint: "Subject to availability and rate" },
      ],
    },
  },
};

export const GUEST_SERVICES = [
  {
    id: "dine",
    moduleKey: "dine",
    path: "/guest/dine",
    category: "eat",
    table: true,
    room: true,
    quick: true,
    title: "Order food",
    hint: "Full restaurant menu",
    synonyms: ["food", "menu", "eat", "hungry", "lunch", "dinner", "dish", "restaurant"],
  },
  {
    id: "room-service",
    moduleKey: "roomService",
    path: "/guest/room-service",
    category: "eat",
    table: false,
    room: true,
    quick: true,
    title: "Room dining",
    hint: "Delicious meals, delivered",
    synonyms: ["room service", "in room", "deliver", "tray"],
  },
  {
    id: "buffet",
    moduleKey: "buffet",
    path: "/guest/buffet",
    category: "eat",
    table: false,
    room: true,
    quick: true,
    title: "Buffet",
    hint: "Breakfast, lunch and dinner hours",
    synonyms: ["breakfast", "brunch", "buffet", "spread"],
  },
  {
    id: "offers",
    moduleKey: "offers",
    path: "/guest/offers",
    category: "eat",
    table: true,
    room: true,
    quick: false,
    title: "Special offers",
    hint: "Exclusive offers for you",
    synonyms: ["offer", "special", "deal", "promo", "discount"],
  },
  {
    id: "events",
    moduleKey: "events",
    path: "/guest/events",
    category: "stay",
    table: true,
    room: true,
    quick: true,
    title: "Events",
    hint: "What’s happening at the hotel",
    synonyms: ["event", "live", "music", "jazz", "tasting", "brunch", "tonight"],
  },
  {
    id: "housekeeping",
    moduleKey: "housekeeping",
    path: "/guest/housekeeping",
    category: "room",
    table: false,
    room: true,
    quick: true,
    title: "Housekeeping",
    hint: "Towels, cleaning, turndown",
    synonyms: ["towel", "towels", "clean", "linen", "pillow", "housekeeping", "maid"],
  },
  {
    id: "laundry",
    moduleKey: "laundry",
    path: "/guest/laundry",
    category: "room",
    table: false,
    room: true,
    quick: false,
    title: "Laundry",
    hint: "Wash, press, or dry clean",
    synonyms: ["laundry", "iron", "press", "dry clean", "clothes"],
  },
  {
    id: "maintenance",
    moduleKey: "maintenance",
    path: "/guest/maintenance",
    category: "room",
    table: false,
    room: true,
    quick: false,
    title: "Maintenance",
    hint: "AC, TV, plumbing, Wi-Fi",
    synonyms: ["ac", "aircon", "tv", "broken", "repair", "plumb", "leak"],
  },
  {
    id: "amenities",
    moduleKey: "amenities",
    path: "/guest/amenities",
    category: "room",
    table: false,
    room: true,
    quick: false,
    title: "In-room extras",
    hint: "Toiletries, iron, cot, minibar",
    synonyms: ["shampoo", "toothbrush", "iron", "cot", "crib", "minibar", "toiletries"],
  },
  {
    id: "stay",
    moduleKey: "stay",
    path: "/guest/stay",
    category: "stay",
    table: true,
    room: true,
    quick: true,
    title: "Hotel facilities",
    hint: "Spa, pool, gym and more",
    synonyms: ["wifi", "wi-fi", "password", "pool", "gym", "spa", "parking", "info"],
  },
  {
    id: "concierge",
    moduleKey: "concierge",
    path: "/guest/concierge",
    category: "help",
    table: false,
    room: true,
    quick: false,
    title: "Concierge",
    hint: "Taxi, tours, reservations",
    synonyms: ["taxi", "cab", "airport", "tour", "wakeup", "wake up"],
  },
  {
    id: "help",
    moduleKey: "help",
    path: "/guest/help",
    category: "help",
    table: true,
    room: true,
    quick: false,
    title: "Help",
    hint: "Waiter, reception, emergency",
    synonyms: ["help", "waiter", "staff", "reception", "front desk", "emergency", "phone"],
  },
  {
    id: "requests",
    moduleKey: "requests",
    path: "/guest/requests",
    category: "help",
    table: true,
    room: true,
    quick: false,
    title: "My requests",
    hint: "Food orders and room requests",
    synonyms: ["status", "track", "order", "request"],
  },
];

export const TABLE_QUICK_IDS = ["offers", "events", "help", "stay"];
export const ROOM_QUICK_IDS = ["housekeeping", "laundry", "offers"];
export const ROOM_FEATURED_IDS = ["room-service", "housekeeping"];
export const TABLE_FEATURED_IDS = ["dine", "offers", "events", "help"];
export const ROOM_FOR_YOU_IDS = ["offers", "buffet", "stay", "events", "concierge", "help"];
export const TABLE_FOR_YOU_IDS = ["stay", "offers", "events", "help", "requests"];

export const HUB_CATEGORIES = [
  { id: "all", label: "All" },
  { id: "eat", label: "Eat" },
  { id: "room", label: "Room" },
  { id: "stay", label: "Stay" },
  { id: "help", label: "Help" },
];

export function mergeGuestPortalConfig(saved = {}) {
  const base = GUEST_PORTAL_DEFAULTS;
  return {
    ...base,
    ...saved,
    modules: { ...base.modules, ...(saved.modules || {}) },
    stay: { ...base.stay, ...(saved.stay || {}) },
    events: (saved.events?.length ? saved.events : base.events).map((event, index) => ({
      ...event,
      image:
        event.image ||
        base.events.find((item) => item.id === event.id)?.image ||
        base.events[index % base.events.length]?.image,
    })),
    buffet: {
      ...base.buffet,
      ...(saved.buffet || {}),
      meals: saved.buffet?.meals?.length ? saved.buffet.meals : base.buffet.meals,
    },
    facilities: saved.facilities?.length ? saved.facilities : base.facilities,
    catalogs: {
      housekeeping: {
        ...base.catalogs.housekeeping,
        ...(saved.catalogs?.housekeeping || {}),
        items: saved.catalogs?.housekeeping?.items?.length
          ? saved.catalogs.housekeeping.items
          : base.catalogs.housekeeping.items,
      },
      laundry: {
        ...base.catalogs.laundry,
        ...(saved.catalogs?.laundry || {}),
        items: saved.catalogs?.laundry?.items?.length
          ? saved.catalogs.laundry.items
          : base.catalogs.laundry.items,
      },
      maintenance: {
        ...base.catalogs.maintenance,
        ...(saved.catalogs?.maintenance || {}),
        items: saved.catalogs?.maintenance?.items?.length
          ? saved.catalogs.maintenance.items
          : base.catalogs.maintenance.items,
      },
      amenities: {
        ...base.catalogs.amenities,
        ...(saved.catalogs?.amenities || {}),
        items: saved.catalogs?.amenities?.items?.length
          ? saved.catalogs.amenities.items
          : base.catalogs.amenities.items,
      },
      concierge: {
        ...base.catalogs.concierge,
        ...(saved.catalogs?.concierge || {}),
        items: saved.catalogs?.concierge?.items?.length
          ? saved.catalogs.concierge.items
          : base.catalogs.concierge.items,
      },
    },
  };
}

export function withGuestSearch(path, search) {
  const qs = search == null ? "" : String(search);
  if (!qs || qs === "?") return path;
  return `${path}${qs.startsWith("?") ? qs : `?${qs}`}`;
}

export function normalizeGuestType(value) {
  const type = String(value || "").trim().toLowerCase();
  return type === "table" || type === "room" ? type : null;
}

/** Table IDs that should open the menu directly (no guest hub). */
const DIRECT_MENU_TABLE_IDS = new Set([
  "6a32d79f-ac06-48f6-b49d-ba5376124c84",
]);

export function shouldOpenGuestMenuDirect(tableId, type) {
  const id = String(tableId || "").trim().toLowerCase();
  if (DIRECT_MENU_TABLE_IDS.has(id)) return true;
  return normalizeGuestType(type) === "table";
}

export function resolveGuestLandingPath(type, tableId) {
  if (shouldOpenGuestMenuDirect(tableId, type)) return "/guest/dine";
  return "/guest";
}

export function buildGuestScanUrl({ origin, companyId, tableId, type }) {
  const params = new URLSearchParams({
    companyId: String(companyId),
    tableId: String(tableId),
  });
  const normalizedType = normalizeGuestType(type);
  if (normalizedType) {
    params.set("type", normalizedType);
  }
  const base = String(origin || window.location.origin).replace(/\/$/, "");
  return `${base}/restaurant-menu?${params.toString()}`;
}

export function flattenMenuItems(menuData = []) {
  const items = [];
  menuData.forEach((category) => {
    (category.MenuItems || category.menuItems || []).forEach((item) => {
      items.push({
        id: item.id,
        name: item.name,
        description: item.description || "",
        categoryName: category.name,
      });
    });
  });
  return items;
}
